const wowApp = require('angular').module('wowApp.auth');

const { signupPageComponentDefinition } = require('./signup-page.component'),
    { signupControllerComponentDefinition } = require('./signup-form.component'),
    { signupFulfilmentComponentDefinition } = require('./signup-fulfilment.component'),
    { SignupService } = require('./signup.service');

wowApp.service('SignupService', SignupService)
    .component('wowSignupPage', signupPageComponentDefinition)
    .component('wowSignupForm', signupControllerComponentDefinition)
    .component('wowSignupFulfilment', signupFulfilmentComponentDefinition);



// WEBPACK FOOTER //
// ./src/auth/signup/index.js